import Config from '@/config/config'

import { getFromLocalStorage, removeFromLocalStorage, setToLocalStorage } from './localstorage'

const { VITE_APP_CLIENT_MONITORING_URL } = Config

const checkDownloadSpeed = async (baseUrl: string, fileSizeInMb: number) => {
  const startTime = performance.now()
  const bitsLoaded = fileSizeInMb * 8 * 1000000

  if (getFromLocalStorage('isMonitoringRunning') === 'true') {
    return 'already running'
  }

  try {
    setToLocalStorage('isMonitoringRunning', 'true')
    const response = await fetch(`${baseUrl}`, { cache: 'no-store' })
    removeFromLocalStorage('isMonitoringRunning')
    if (!response.ok) return 'unable to fetch'

    const endTime = performance.now()
    const duration = (endTime - startTime) / 1000
    const speedBps = bitsLoaded / duration
    const speedMbps = speedBps / 1000000

    return speedMbps.toFixed(2)
  } catch (error) {
    removeFromLocalStorage('isMonitoringRunning')
    return 'error fetching'
  }
}

export const getNetworkDownloadSpeedInMBPS = async () => {
  return await checkDownloadSpeed(VITE_APP_CLIENT_MONITORING_URL, 5)
}
